import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import BackspaceIcon from "@mui/icons-material/Backspace";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import { visuallyHidden } from "@mui/utils";
import { useTheme } from "@mui/material/styles";
import {
  Box,
  Button,
  Divider,
  FormControl,
  InputLabel,
  MenuItem,
  Modal,
  Paper,
  Select,
  Stack,
  Switch,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import { Chip, CloseIcon } from "../mui";
import Autocomplete from "@mui/material/Autocomplete";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useEffect, useState } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { useDispatch } from "react-redux";
import UIWrapper from "../components/UIWrapper";
import BiService from "../services/BiService";
import { snackbarActions } from "../Store/snackbar";
import Header from "./acsComp/Header";
import ExportDownloads from "./exportDownloads";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import AcsCustomExport from "./AcsCustomExport";
import { Grid } from "@mui/material";

const icons = {
  1: <FormatListBulletedIcon />,
  2: <FilterAltIcon />,
  3: <FactCheckIcon />,
  4: <ImportExportIcon />,
};
const filterInputs = {
  field_name: "",
  condition: "",
  value: "",
};
const style = {
  position: "absolute",
  display: "flex",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "30%",
  bgcolor: "background.paper",
  // border: '2px solid #000',
  boxShadow: 24,
  p: 3,
};
const steps = ["Study/Project Profile", "Filter", "Mappings", "Export"];

const AcsExport = (props) => {
  const [selectionView, setSelectionView] = useState(false);
  const [filterView, setFilterView] = useState(false);
  const [mappingView, setMappingView] = useState(false);
  const [searchedDetail, setSearchedDetail] = useState(false);
  const [value, setValue] = useState("one");

  const [profile, setProfile] = useState("");
  const [profileList, setProfileList] = useState([]);

  const [profileNameList, setProfileNameList] = useState([]);

  const [profileName, setProfileName] = useState("");
  const [clientState, setClientState] = useState("");
  const [projectState, setProjectState] = useState([]);
  const [clientOptions, setClientOptions] = useState([]);
  const [projectOptions, setProjectOptions] = useState([]);
  const [filterList, setFilterList] = useState([]);
  const [filterData, setFilterData] = useState({});
  const [headerData, setHeaderData] = useState(null);
  const [transferData, setTransferData] = useState([]);
  const [filtersCondition, setFiltersCondition] = useState([]);
  const [open, setOpen] = useState(false);
  const [alias, setAlias] = useState(true);
  const [exportType, setExportType] = useState("csv");
  const [headerOption, setHeaderOption] = useState("no");
  const dispatch = useDispatch();
  const theme = useTheme();

  const handleViewChange = (value) => {
    if (value === "Client/Project Selection")
      setSelectionView((prevView) => !prevView);
    if (value === "Filter") setFilterView((prevView) => !prevView);
    if (value === "Mapping") setMappingView((prevView) => !prevView);
  };

  const handleChangeArray = (value, index) => {
    let clone = filtersCondition.slice(0);
    clone[index] = value;
    setFiltersCondition(clone);
  };
  const doExport = async () => {
    let orderList = [];
    transferData.forEach((ele) => {
      orderList.push(ele.field);
    });
    let temp = [];
    let isFilterValueEmpty = false;
    filterList.forEach((ele, index) => {
      Object.values(filterList[index]).forEach((option) => {
        if (option === "") isFilterValueEmpty = true;
      });
      temp.push([
        filtersCondition[index]?.toLowerCase()
          ? filtersCondition[index].toLowerCase()
          : "and",
        ...Object.values(filterList[index]),
      ]);
    });

    let profile = {
      client: clientState,
      projects: projectState,
      filters: temp,
      order: orderList,
      export_type: exportType,  
      include_header: headerOption === "yes" ? true : false
    };

    if (isFilterValueEmpty) {
      dispatch(
        snackbarActions.showNotification({
          snackbarOpen: true,
          snackbarType: "error",
          snackbarMessage: "A Filter Value is Empty",
        })
      );
    } else {
      await BiService.doExport(profile)
        .then((resp) => {
          dispatch(
            snackbarActions.showNotification({
              snackbarOpen: true,
              snackbarType: "success",
              snackbarMessage: "Successful Exported",
            })
          );
          setValue("two");
        })
        .catch((err) => {
          console.log(err);
          dispatch(
            snackbarActions.showNotification({
              snackbarOpen: true,
              snackbarType: "error",
              snackbarMessage: "Failed to Export",
            })
          );
        });
    }
  };

  const saveProfile = async () => {
    let orderList = [];
    transferData.forEach((ele) => {
      orderList.push(ele.field);
    });

    let temp = [];
    filterList.forEach((ele, index) => {
      temp.push(Object.values(filterList[index]));
    });

    let profile = {
      client: clientState,
      projects: projectState,
      name: profileName,
      filters: temp,
      order: orderList,
    };

    await BiService.saveProfile(profile)
      .then((resp) => {
        dispatch(
          snackbarActions.showNotification({
            snackbarOpen: true,
            snackbarType: "success",
            snackbarMessage: "Profile Successful Saved",
          })
        );
        setOpen(false);
        setProfileName("");
      })
      .catch((err) => {
        dispatch(
          snackbarActions.showNotification({
            snackbarOpen: true,
            snackbarType: "error",
            snackbarMessage: "Failed to Save Profile",
          })
        );
        setOpen(false);
        setProfileName("");
      });
  };

  const handleSubmission = async (value) => {
    let finalFilter = [];
    let finalTransfer = [];
    let client = "";
    let project = [];

    if (profile) {
      profileList.forEach((ele) => {
        if (ele.name === profile) {
          client = ele.client;
          project = ele.projects;

          setClientState(ele.client);
          setProjectState(ele.projects);

          ele.filters.forEach((option) => {
            let temp = {};
            temp["field_name"] = option[0];
            temp["condition"] = option[1];
            temp["value"] = option[2];
            finalFilter.push(temp);
          });
          finalTransfer = ele.order;
        }
      });
    }
    await BiService.getFilters()
      .then((resp) => {
        setSearchedDetail(true);
        setFilterData(resp.data);
        if (finalFilter.length) setFilterList(finalFilter);
        setMappingView(true);
      })
      .catch((err) => {
        console.log(err);
        setSearchedDetail(false);
      });
    await BiService.getFieldHeaders(
      client ? client : clientState,
      project.length ? project : projectState
    )
      .then((resp) => {
        let newList = resp.data;
        Object.keys(newList).forEach((ele, index) => {
          newList[ele]["checked"] = finalTransfer.includes(ele) ? true : false;
        });
        setHeaderData(newList);
        let finalTransferList = [];
        finalTransfer.forEach((ele) => {
          let temp = {};
          temp["field"] = ele;
          temp["alias"] = resp.data[ele]["alias"];
          finalTransferList.push(temp);
        });
        setTransferData(finalTransferList);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleFilterEvent = (event) => {
    event.preventDefault();
  };

  const addFilter = (e) => {
    if (filterInputs) {
      let copy = filtersCondition.slice(0);
      copy.push("AND");
      setFiltersCondition(copy);

      let newList = filterList.slice(0);
      newList.push(JSON.parse(JSON.stringify(filterInputs)));
      setFilterList(newList);
    }
  };
  const handleProfileChange = (e) => {
    setProfileName(e.target.value);
  };
  const changeFilterField = (index, newVal) => {
    let newList = [...filterList];
    newList[index].field_name = newVal;
    newList[index]["condition"] = "";
    setFilterList(newList);
  };

  const changeFilterFil = (index, newVal) => {
    let newList = [...filterList];
    newList[index]["condition"] = newVal;
    setFilterList(newList);
  };
  const changeFilterVal = (e, index) => {
    let newList = [...filterList];
    newList[index]["value"] = e.target.value;
    setFilterList(newList);
  };

  const handleCheckAll = () => {
    let newData = JSON.parse(JSON.stringify(headerData));
    Object.keys(newData).forEach((ele) => {
      newData[ele]["checked"] = true;
    });
    setHeaderData(newData);
  };

  const handleUncheckAll = () => {
    let newData = JSON.parse(JSON.stringify(headerData));
    Object.keys(newData).forEach((ele) => {
      newData[ele]["checked"] = false;
    });
    setHeaderData(newData);
  };

  const handleCheckChange = (ele) => {
    let newData = JSON.parse(JSON.stringify(headerData));
    newData[ele]["checked"] = !newData[ele]["checked"];
    setHeaderData(newData);
  };
  const transferHeaders = () => {
    const transferNew = [];
    Object.keys(headerData).forEach((ele) => {
      if (headerData[ele]["checked"] === true) {
        transferNew.push({ field: ele, alias: headerData[ele]["alias"] });
      }
    });
    setTransferData(transferNew);
  };

  let handleFilterDelete = (eleIndex) => {
    let temp = [...filterList];
    temp.splice(eleIndex, 1);
    setFilterList(temp);
  };
  const handleDateChange = (index, newValue) => {
    const dte = dayjs(newValue.$d).format("YYYY-MM-DD");
    let newList = [...filterList];

    newList[index]["value"] = dte;
    setFilterList(newList);
  };

  const onDragEnd = (result) => {
    if (
      !result.destination ||
      result.destination.index === result.source.index
    ) {
      return;
    }
    const newItems = Array.from(transferData);
    const [removed] = newItems.splice(result.source.index, 1);
    newItems.splice(result.destination.index, 0, removed);
    setTransferData(newItems);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    BiService.getAllClients("")
      .then((resp) => setClientOptions(resp.data))
      .catch((err) => {
        console.log(err);
      });
  }, []);
  useEffect(() => {
    BiService.searchProjects(clientState, projectState)
      .then((resp) => setProjectOptions(resp.data))
      .catch((err) => {
        console.log(err);
      });
  }, [clientState]);

  useEffect(() => {
    BiService.getProfiles(profile)
      .then((resp) => {
        let list = [];
        resp.data.forEach((ele) => {
          list.push(ele.name);
        });
        setProfileNameList(list);
        setProfileList(resp.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [profile]);

  const handleToggle = (event) => {
    // Prevent default action if the event is triggered by keyboard
    if (
      event.type === "keydown" &&
      event.key !== "Enter" &&
      event.key !== " "
    ) {
      return;
    }
    setAlias((prev) => !prev);
  };

  return (
    <UIWrapper title="Export Samples" paper>
      <h1 style={visuallyHidden}>Welcome to Sampled Sphere</h1>
      <Box>
        <Tabs
          value={value}
          onChange={handleChange}
          textColor="primary"
          indicatorColor="primary"
          aria-label="primary tabs example"
        >
          <Tab value="one" label="Basic Export" />
          <Tab value="three" label="Custom Export" />
          <Tab value="two" label="Downloads" />
        </Tabs>
        <Divider style={{ width: "100%" }}></Divider>
        {value === "two" && <ExportDownloads type="export"></ExportDownloads>}
        {value === "three" && <AcsCustomExport setValue={setValue} />}
        {value === "one" && (
          <Box style={{ marginTop: "20px" }}>
            <Header
              header={"Client/Project Selection"}
              selected={true}
              handleViewChange={handleViewChange}
            />
            {
              <Stack direction="row" style={{ padding: "15px" }}>
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="left"
                  sx={{ width: "100%" }}
                >
                  <FormControl variant="standard" sx={{ width: "20%" }}>
                    <Autocomplete
                      aria-label="Select a profile"
                      id="tags-standard"
                      freeSolo
                      size="small"
                      options={profileNameList}
                      onChange={(e, new_value) => setProfile(new_value)}
                      renderInput={(params) => (
                        <TextField margin="dense" {...params} label="Profile" />
                      )}
                      value={profile || ""}
                    />
                  </FormControl>

                  <Typography
                    tabIndex={0}
                    role="button"
                    sx={{
                      marginTop: "20px",
                      paddingLeft: "20px",
                      paddingRight: "20px",
                      color: (theme) =>
                        theme.palette.mode === "dark"
                          ? "#FFFFFF" // Pure white for dark mode
                          : "#6B2BA8",
                      padding: "4px 20px",
                      borderRadius: "4px",
                      "&:focus": {
                        outline: "2px solid",
                        outlineColor: (theme) =>
                          theme.palette.mode === "dark" ? "#FFFFFF" : "#6B2BA8",
                        outlineOffset: "2px",
                      },
                    }}
                  >
                    OR
                  </Typography>

                  <FormControl variant="standard" sx={{ width: "20%" }}>
                    <Autocomplete
                      aria-label="Select a Client"
                      id="free-solo-demo"
                      freeSolo
                      size="small"
                      margin="dense"
                      options={clientOptions}
                      onChange={(e, new_value) => setClientState(new_value)}
                      renderInput={(params) => (
                        <TextField margin="dense" {...params} label="Client" />
                      )}
                      value={clientState || ""}
                    />
                  </FormControl>

                  <ArrowRightAltIcon
                    tabIndex={0}
                    role="button"
                    aria-hidden="false"
                    fontSize="large"
                    style={{
                      color: "#9b51e0",
                      marginTop: "4px",
                      paddingLeft: "10px",
                      paddingRight: "10px",
                    }}
                  ></ArrowRightAltIcon>

                  <FormControl variant="standard" sx={{ width: "20%" }}>
                    <Autocomplete
                      multiple
                      id="tags-standard"
                      freeSolo
                      size="small"
                      aria-disabled={!clientState}
                      options={clientState ? projectOptions : []}
                      onChange={(e, newValue) => setProjectState(newValue)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          // Handle manual entry if needed
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          margin="dense"
                          label="Project"
                          aria-label={
                            !clientState
                              ? "Select a client first to enable project selection"
                              : "Select project"
                          }
                          inputProps={{
                            ...params.inputProps,
                            readOnly: !clientState, // Set readOnly instead of disabled
                          }}
                        />
                      )}
                      value={projectState || []} // Ensure value is an array
                      disableCloseOnSelect
                      openOnFocus
                      handleHomeEndKeys
                      selectOnFocus
                      clearOnBlur={false}
                      renderTags={(value, getTagProps) =>
                        value.map((option, index) => (
                          <Chip
                            {...getTagProps({ index })}
                            key={index}
                            label={option}
                            deleteIcon={<CloseIcon />}
                            onClick={(e) => {
                              const newValue = [...value];
                              newValue.splice(index, 1);
                              setProjectState(newValue);
                            }}
                            onDelete={() => {
                              const newValue = [...value];
                              newValue.splice(index, 1);
                              setProjectState(newValue);
                            }}
                            onKeyDown={(e) => {
                              if (e.key === "Enter" || e.key === " ") {
                                e.preventDefault();
                                const newValue = [...value];
                                newValue.splice(index, 1);
                                setProjectState(newValue);
                              }
                            }}
                            tabIndex={0}
                            aria-label={`selected item ${option} and can be removed`}
                          />
                        ))
                      }
                      sx={{
                        "& .MuiInputLabel-root": {
                          color:
                            theme.palette.mode === "light"
                              ? "rgba(0, 0, 0, 0.54)"
                              : "rgba(255, 255, 255, 0.7)",
                        },
                        "& .MuiInputBase-input::placeholder": {
                          color:
                            theme.palette.mode === "light"
                              ? "rgba(0, 0, 0, 0.54)"
                              : "rgba(255, 255, 255, 0.7)",
                          opacity: 1,
                        },
                        "& .MuiAutocomplete-tag": {
                          "&:focus": {
                            outline: "2px solid #9b51e0",
                            outlineOffset: "2px",
                          },
                        },
                        "& .MuiAutocomplete-input": {
                          "&:focus": {
                            outline: "none",
                          },
                        },
                      }}
                    />
                  </FormControl>

                  <Button
                    type="submit"
                    variant="contained"
                    onClick={handleSubmission}
                    style={{ margin: "15px" }}
                  >
                    Search
                  </Button>
                </Stack>
              </Stack>
            }
            <Header
              header={"Filter"}
              selected={filterView}
              handleViewChange={handleViewChange}
            />
            {searchedDetail && (
              <Stack
                style={{
                  padding: "15px",
                  display: filterView ? "block" : "none",
                  overflow: "auto",
                  maxHeight: "300px",
                }}
                sx={{ width: "100%" }}
              >
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="flex-start"
                  sx={{ width: "99%" }}
                >
                  <Button
                    onClick={(e) => addFilter(e)}
                    style={{ cursor: "pointer" }}
                  >
                    <AddCircleOutlineIcon
                      fontSize="medium"
                      style={{
                        color: "#9b51e0",
                        paddingLeft: "0px",
                        paddingRight: "10px",
                        cursor: "pointer",
                      }}
                      // onClick={() => setFilterList(filterList => [...filterList, 1])}
                    ></AddCircleOutlineIcon>
                    <Typography variant="body1" color="secondary">
                      Add Filter
                    </Typography>
                  </Button>
                </Stack>

                <form onSubmit={handleFilterEvent}>
                  {Object.keys(filterList).map((ele, index) => (
                    <Stack
                      alignItems="flex-start"
                      justifyContent="flex-start"
                      sx={{ width: "100%", position: "relative" }}
                      key={index}
                    >
                      {filterList.length !== 0 && index !== 0 && (
                        <Stack
                          direction="row"
                          justifyContent="flex-start" // Centers the AND/OR dropdown
                          alignItems="center"
                          sx={{
                            width: "100%",
                            marginTop: "10px",
                            paddingLeft: "calc(30% + 10px)",
                          }}
                        >
                          <FormControl
                            variant="standard"
                            sx={{
                              width: "8%",
                            }}
                          >
                            <InputLabel id="and-or-id">AND/OR</InputLabel>
                            <Select
                              labelId="and-or-id"
                              label="AND/OR"
                              value={filtersCondition[index]}
                              onChange={(event) =>
                                handleChangeArray(event.target.value, index)
                              }
                            >
                              <MenuItem value={"AND"}>AND</MenuItem>
                              <MenuItem value={"OR"}>OR</MenuItem>
                            </Select>
                          </FormControl>
                        </Stack>
                      )}

                      <Stack
                        direction="row"
                        alignItems="center"
                        justifyContent="flex-start"
                        sx={{ width: "100%" }}
                        key={index}
                      >
                        <Autocomplete
                          aria-label="Select a field name"
                          id="free-solo-demo"
                          sx={{ width: "20%" }}
                          freeSolo
                          size="small"
                          margin="dense"
                          options={Object.keys(filterData)}
                          onChange={(e, new_value) =>
                            changeFilterField(index, new_value)
                          }
                          renderInput={(params) => (
                            <TextField
                              margin="dense"
                              {...params}
                              label="Field Name"
                              aria-label="Select a field name"
                            />
                          )}
                          value={filterList[index]["field_name"] || ""}
                        />

                        <ArrowRightAltIcon
                          fontSize="large"
                          tabIndex={0}
                          aria-hidden="false"
                          role="button"
                          style={{
                            color: "#9b51e0",
                            marginTop: "4px",
                            paddingLeft: "10px",
                            paddingRight: "10px",
                          }}
                        ></ArrowRightAltIcon>

                        <Autocomplete
                          id="free-solo-demo"
                          sx={{
                            width: "20%",
                            "& .MuiInputLabel-root": {
                              color:
                                theme.palette.mode === "light"
                                  ? "rgba(0, 0, 0, 0.54)"
                                  : "rgba(255, 255, 255, 0.7)",
                            },
                            "& .MuiInputBase-input::placeholder": {
                              color:
                                theme.palette.mode === "light"
                                  ? "rgba(0, 0, 0, 0.54)"
                                  : "rgba(255, 255, 255, 0.7)",
                              opacity: 1,
                            },
                            // Add styles for disabled state
                            "&[aria-disabled='true']": {
                              backgroundColor:
                                theme.palette.mode === "dark"
                                  ? "rgb(18, 18, 18)"
                                  : "rgb(255, 255, 255)",
                              "& .MuiInputBase-root": {
                                color:
                                  theme.palette.mode === "dark"
                                    ? "rgba(255, 255, 255, 0.38)"
                                    : "rgba(0, 0, 0, 0.38)",
                              },
                              "& .MuiOutlinedInput-notchedOutline": {
                                borderColor:
                                  theme.palette.mode === "dark"
                                    ? "rgba(255, 255, 255, 0.23)"
                                    : "rgba(0, 0, 0, 0.23)",
                              },
                            },
                            // Add focus styles
                            "&:focus-within": {
                              "& .MuiOutlinedInput-notchedOutline": {
                                borderColor: "primary.main",
                                borderWidth: 2,
                              },
                            },
                          }}
                          freeSolo
                          size="small"
                          margin="dense"
                          options={
                            filterList[index]["field_name"]
                              ? filterData[filterList[index]["field_name"]][
                                  "conditions"
                                ]
                              : []
                          }
                          onChange={(e, new_value) => {
                            if (!filterList[index]["field_name"]) return;
                            changeFilterFil(index, new_value);
                          }}
                          renderInput={(params) => (
                            <TextField
                              margin="dense"
                              {...params}
                              label="Condition"
                              aria-label="Select a condition"
                              inputProps={{
                                ...params.inputProps,
                                "aria-disabled":
                                  !filterList[index]["field_name"],
                              }}
                            />
                          )}
                          value={filterList[index]["condition"] || ""}
                          aria-disabled={!filterList[index]["field_name"]}
                          readOnly={!filterList[index]["field_name"]}
                        />

                        <ArrowRightAltIcon
                          tabIndex={0}
                          aria-hidden="false"
                          role="button"
                          fontSize="large"
                          style={{
                            color: "#9b51e0",
                            marginTop: "4px",
                            paddingLeft: "10px",
                            paddingRight: "10px",
                          }}
                        ></ArrowRightAltIcon>

                        <FormControl variant="standard" sx={{ width: "20%" }}>
                          {filterList[index]["field_name"] ? (
                            filterData[filterList[index]["field_name"]][
                              "type"
                            ] === "date" ? (
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                  // label="Select Date"
                                  inputFormat="YYYY-MM-DD"
                                  //   helperText="DD/MM/YYYY"
                                  value={dayjs(filterList[index]["value"])}
                                  onChange={(newValue) => {
                                    handleDateChange(index, dayjs(newValue));
                                  }}
                                  renderInput={(props) => (
                                    <TextField
                                      {...props}
                                      inputProps={{
                                        ...props.inputProps,
                                        readOnly: true,
                                      }}
                                      helperText="Select Date(yyyy-mm-dd)"
                                      placeHolderText="YYYY-MM-DD"
                                      variant="standard"
                                    />
                                  )}
                                />
                              </LocalizationProvider>
                            ) : (
                              <TextField
                                label={"Filter Value"}
                                variant="standard"
                                onChange={(e, new_value) =>
                                  changeFilterVal(e, index, new_value)
                                }
                                value={filterList[index]["value"] || ""}
                              />
                            )
                          ) : (
                            <TextField
                              label={"Filter Value"}
                              variant="standard"
                              onChange={(e, new_value) =>
                                changeFilterVal(e, index, new_value)
                              }
                              value={filterList[index]["value"] || ""}
                            />
                          )}
                        </FormControl>

                        <BackspaceIcon
                          fontSize="medium"
                          style={{
                            color: "#EE3263",
                            marginTop: "4px",
                            paddingLeft: "10px",
                            paddingRight: "10px",
                            cursor: "pointer",
                          }}
                          aria-hidden="false"
                          onClick={() => handleFilterDelete(index)}
                          onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {
                              e.preventDefault();
                              handleFilterDelete(index);
                            }
                          }}
                          tabIndex={0}
                          role="button"
                          aria-label="Delete Filter"
                        ></BackspaceIcon>
                      </Stack>
                    </Stack>
                  ))}
                </form>
              </Stack>
            )}

            <Header
              header={"Mapping"}
              selected={mappingView}
              handleViewChange={handleViewChange}
            />
            {searchedDetail && (
              <Stack
                style={{
                  padding: "15px",
                  display: mappingView ? "block" : "none",
                }}
                sx={{ width: "100%" }}
              >
                <FormControlLabel
                  control={
                    // <Switch
                    //   checked={alias}
                    //   onChange={handleToggle}
                    //   onKeyDown={handleToggle} // Handle keyboard events
                    //   inputProps={{
                    //     "aria-label": "Alias toggle", // Provide an accessible label
                    //   }}
                    // />
                    <div
                      role="switch" // This indicates it's a toggle switch.
                      tabIndex={0}
                      aria-checked={alias} // Accessibility attribute
                      onClick={handleToggle} // Handle click event to toggle
                      onKeyDown={(event) => {
                        if (event.key === "Enter" || event.key === " ") {
                          event.preventDefault(); // Prevent scrolling when space is pressed
                          handleToggle(); // Toggle the switch
                        }
                      }}
                      aria-label="Alias toggle"
                      style={{
                        width: "40px", // Adjust width for a switch
                        height: "15px", // Adjust height for a switch
                        borderRadius: "20px", // Give a rounded look
                        backgroundColor: alias
                          ? "#cda8ef"
                          : "rgba(0, 0, 0, 0.38)", // Background color based on state
                        display: "flex",
                        alignItems: "center",
                        justifyContent: alias ? "flex-end" : "flex-start", // Align toggle based on state
                        cursor: "pointer",
                        marginLeft: "5px",
                      }}
                    >
                      <div
                        style={{
                          width: "20px", // Size of the toggle knob
                          height: "20px",
                          borderRadius: "50%",
                          backgroundColor: alias ? "#9b51e0" : "white", // Knob color
                          transition: "0.3s ease", // Smooth transition
                          boxShadow:
                            "0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)",
                        }}
                      />
                    </div>
                    // <input
                    //   type="checkbox"
                    //   tabIndex={0}
                    //   value={alias}
                    //   checked={alias}
                    //   onChange={handleToggle}
                    //   onKeyDown={(event) => {
                    //     // Handle keyboard events for toggling
                    //     if (event.key === "Enter" || event.key === " ") {
                    //       event.preventDefault(); // Prevent scrolling when space is pressed
                    //       handleToggle(); // Toggle the checkbox
                    //     }
                    //   }}
                    //   aria-label="Alias toggle"
                    //   style={{
                    //     width: "1em",
                    //     height: "1em",
                    //     border: "2px solid rgb(0, 0, 0, 0.6)",
                    //     //outline: "2px solid blue;",
                    //     cursor: "pointer",
                    //     marginRight: "8px",
                    //     position: "relative",
                    //     fontSize: "1em",
                    //     accentColor: alias ? "#9b51e0" : "white",
                    //     backgroundColor: alias ? "#9b51e0" : "white",
                    //   }}
                    //   sx={{
                    //     "&:focus": {
                    //       outline: "2px solid #9b51e0",
                    //     },
                    //   }}
                    // />
                  }
                  labelPlacement="start"
                  label={
                    <Typography
                      variant="h2"
                      component="span"
                      color="secondary.main"
                      sx={{
                        fontSize: "18px",
                        marginRight: "5px",
                        cursor: "pointer",
                      }}
                      aria-hidden="true"
                    >
                      Alias
                    </Typography>
                  }
                />
                {/* <div
                  role="group"
                  aria-labelledby="alias-label"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <Typography
                    id="alias-label"
                    variant="h2"
                    component="span"
                    tabIndex={0}
                    role={"button"}
                    htmlFor="alias-switch"
                    color="secondary.main"
                    sx={{
                      fontSize: "18px",
                      marginRight: "8px",
                      cursor: "pointer",
                    }}
                    onClick={() => setAlias((prev) => !prev)}
                    onKeyDown={handleKeyDown}
                  >
                    Alias
                  </Typography>
                  <Switch
                    id="alias-switch"
                    checked={alias}
                    onChange={() => setAlias((prev) => !prev)}
                    onKeyDown={handleKeyDown}
                    tabIndex={0}
                    inputProps={{
                      "aria-labelledby": "alias-label", // Associate the switch with the label
                      role: "switch",
                      "aria-checked": alias,
                    }}
                  />
                </div> */}

                <Grid container spacing={1} style={{ padding: "0px" }}>
                  {/* Fields Section */}
                  <Grid item xs={6} md={5.5}>
                    <Stack style={{ width: "100%" }}>
                      <Typography
                        variant="h2"
                        color="secondary.main"
                        component={"div"}
                        role={"button"}
                        tabIndex={0}
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          fontSize: "18px",
                        }}
                      >
                        Fields
                      </Typography>
                      <Stack
                        direction="row"
                        sx={{ width: "100%" }}
                        alignItems="center"
                        justifyContent="center"
                      >
                        <Button
                          variant="outlined"
                          onClick={handleCheckAll}
                          style={{ margin: "5px" }}
                        >
                          Check All
                        </Button>
                        <Button
                          variant="outlined"
                          onClick={handleUncheckAll}
                          style={{ margin: "5px" }}
                        >
                          Uncheck All
                        </Button>
                      </Stack>
                      <Paper
                        sx={{
                          width: "100%",
                          height: "400px",
                          overflow: "auto",
                        }}
                        style={{ margin: "0px" }}
                        elevation={0}
                        variant="outlined"
                      >
                        <Stack sx={{ padding: "3px 0px 0px 10px" }}>
                          {headerData &&
                            Object.keys(headerData)
                              .sort()
                              .map((ele, index) => (
                                <Stack
                                  direction="row"
                                  key={index}
                                  sx={{ width: "90%", paddingLeft: "5px" }}
                                >
                                  <FormControlLabel
                                    key={ele}
                                    control={
                                      <input
                                        type="checkbox"
                                        tabIndex={0}
                                        value={headerData[ele]["checked"]}
                                        checked={headerData[ele]["checked"]}
                                        onChange={() => handleCheckChange(ele)}
                                        onKeyDown={(event) => {
                                          // Handle keyboard events for toggling
                                          if (
                                            event.key === "Enter" ||
                                            event.key === " "
                                          ) {
                                            event.preventDefault(); // Prevent scrolling when space is pressed
                                            handleCheckChange(ele); // Toggle the checkbox
                                          }
                                        }}
                                        aria-label={`Checkbox for ${ele}`}
                                        style={{
                                          width: "1em",
                                          height: "1em",
                                          border: "2px solid rgb(0, 0, 0, 0.6)",
                                          //outline: "2px solid blue;",
                                          cursor: "pointer",
                                          marginRight: "8px",
                                          position: "relative",
                                          fontSize: "1em",
                                          accentColor: headerData[ele][
                                            "checked"
                                          ]
                                            ? "#9b51e0"
                                            : "white",
                                          backgroundColor: headerData[ele][
                                            "checked"
                                          ]
                                            ? "#9b51e0"
                                            : "white",
                                        }}
                                        onFocus={(event) => {
                                          event.target.style.outline =
                                            "2px solid #9b51e0"; // Visual focus indicator
                                        }}
                                        onBlur={(event) => {
                                          event.target.style.outline = "none"; // Remove focus indicator
                                        }}
                                      />
                                    }
                                    label={
                                      <Typography
                                        component="span"
                                        variant="body1"
                                        className="field-label"
                                        role="status"
                                        tabIndex={0} // Make the label focusable
                                        onKeyDown={(event) => {
                                          // Allow toggling the checkbox when the label is focused
                                          if (
                                            event.key === "Enter" ||
                                            event.key === " "
                                          ) {
                                            event.preventDefault();
                                            handleCheckChange(ele); // Toggle the checkbox
                                          }
                                        }}
                                      >
                                        {alias
                                          ? headerData[ele]["alias"]
                                          : ele || "NA"}
                                      </Typography>
                                    }
                                    aria-label={`Select ${
                                      alias
                                        ? headerData[ele]["alias"]
                                        : ele || "NA"
                                    }`}
                                    sx={{
                                      cursor: "pointer",
                                      paddingTop: "15px",
                                    }}
                                  />
                                </Stack>
                              ))}
                        </Stack>
                      </Paper>
                    </Stack>
                  </Grid>

                  {/* Arrow Icon for Mapping */}
                  <Grid
                    item
                    xs={0}
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    sx={{ marginLeft: "20px" }}
                  >
                    <CompareArrowsIcon
                      fontSize="large"
                      sx={{
                        color: "#9b51e0",
                        cursor: "pointer",
                        "&.MuiSvgIcon - root:focus": {
                          outline: "2px solid #9b51e0",
                          outlineOffset: "2px",
                        },
                      }}
                      onClick={transferHeaders}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          transferHeaders();
                        }
                      }}
                      tabIndex={0}
                      role="button"
                      aria-label="Transfer headers"
                      aria-hidden="false"
                    />
                  </Grid>

                  {/* Export Fields Section */}
                  <Grid item xs={6} md={5.5}>
                    <Stack style={{ width: "100%" }}>
                      <Typography
                        variant="h2"
                        color="secondary.main"
                        component={"div"}
                        role={"button"}
                        tabIndex={0}
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          fontSize: "18px",
                        }}
                      >
                        Export Fields
                      </Typography>
                      <Button
                        variant="contained"
                        color="success"
                        style={{ marginLeft: "20px" }}
                        onClick={() => setOpen(true)}
                      >
                        <SaveAltIcon
                          fontSize="medium"
                          style={{
                            paddingLeft: "5px",
                            paddingRight: "5px",
                          }}
                        />
                        Save Profile
                      </Button>
                      <Paper
                        sx={{
                          width: "100%",
                          height: "400px",
                          overflow: "auto",
                        }}
                        style={{ margin: "5px" }}
                        elevation={0}
                        variant="outlined"
                      >
                        <DragDropContext onDragEnd={onDragEnd}>
                          <Droppable droppableId="droppable">
                            {(provided, snapshot) => (
                              <div
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                              >
                                {transferData.map((item, index) => (
                                  <Draggable
                                    draggableId={item.field}
                                    index={index}
                                    key={item.field}
                                  >
                                    {(provided, snapshot) => (
                                      <Stack
                                        direction="row"
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        sx={{
                                          marginBottom: "3px",
                                          background: "rgb(211,211,211,0.8)",
                                        }}
                                      >
                                        <DragIndicatorIcon
                                          fontSize="medium"
                                          style={{
                                            color: "#9b51e0",
                                            paddingLeft: "5px",
                                            paddingRight: "10px",
                                          }}
                                        />
                                        <Typography
                                          component="span"
                                          variant="body1"
                                          key={index}
                                          sx={{
                                            display: "block",
                                            fontSize: "1rem",
                                            fontWeight: "normal",
                                            color:
                                              theme.palette.mode === "dark"
                                                ? "#ffffff" // White text for dark mode
                                                : "#000000", // Black text for light mode
                                            backgroundColor:
                                              theme.palette.mode === "dark"
                                                ? "#2c2c2c" // Darker background for dark mode
                                                : "#e0e0e0", // Light gray for light mode
                                            padding: "8px",
                                            borderRadius: "4px",
                                            marginBottom: "2px",
                                            "&:focus": {
                                              outline: `2px solid ${theme.palette.primary.main}`,
                                              outlineOffset: "2px",
                                            },
                                          }}
                                        >
                                          {alias
                                            ? item["alias"] || "none"
                                            : item.field}
                                        </Typography>
                                        {provided.placeholder}
                                      </Stack>
                                    )}
                                  </Draggable>
                                ))}
                              </div>
                            )}
                          </Droppable>
                        </DragDropContext>
                      </Paper>
                    </Stack>
                  </Grid>
                </Grid>
              </Stack>
            )}
            
            <Stack 
            direction="row" 
            spacing={2} 
            alignItems="center" 
            justifyContent="flex-start"
            sx={{ 
              padding: "15px",
              marginTop: "20px",
              borderTop: "1px solid #e0e0e0"
            }}
          >
            <FormControl variant="standard" sx={{ width: "20%" }} disabled={!searchedDetail}>
              <InputLabel>Export Type</InputLabel>
              <Select
                value={exportType}
                onChange={(e) => setExportType(e.target.value)}
                label="Export Type"
              >
                <MenuItem value="csv">CSV-Double quotes</MenuItem>
                <MenuItem value="pdf">PDF</MenuItem>
                <MenuItem value="txt">TXT</MenuItem>
                <MenuItem value="csv_single_quote">CSV-Single quote in beginning</MenuItem>
              </Select>
            </FormControl>

            <FormControl variant="standard" sx={{ width: "20%" }} disabled={!searchedDetail}>
              <InputLabel>Header Row</InputLabel>
              <Select
                value={headerOption}
                onChange={(e) => setHeaderOption(e.target.value)}
                label="Header Row"
              >
                <MenuItem value="yes">Yes</MenuItem>
                <MenuItem value="no">No</MenuItem>
              </Select>
            </FormControl>

            <div
              role="button"
              tabIndex={0}
              onClick={!searchedDetail ? undefined : doExport}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  if (searchedDetail) doExport();
                }
              }}
              aria-disabled={!searchedDetail}
              style={{
                display: "inline-flex",
                alignItems: "center",
                padding: "5px 10px",
                backgroundColor: !searchedDetail
                  ? theme.palette.mode === "dark"
                    ? "rgba(255, 255, 255, 0.12)"
                    : "rgba(0, 0, 0, 0.12)"
                  : theme.palette.mode === "dark"
                  ? "#1976d2" // Changed to darker blue for better contrast in dark mode
                  : "#0077cc", // Darker blue for light mode

                color: !searchedDetail
                  ? theme.palette.mode === "dark"
                    ? "rgba(255, 255, 255, 0.7)" // Increased opacity for better contrast
                    : "rgba(0, 0, 0, 0.38)"
                  : "#ffffff", // White text for both themes when enabled
                cursor: !searchedDetail ? "not-allowed" : "pointer",
                margin: "10px",
                borderRadius: "4px",
                opacity: !searchedDetail ? 0.7 : 1,
                transition: "background-color 0.2s, color 0.2s",
                "&:hover": !searchedDetail
                  ? undefined
                  : {
                      backgroundColor:
                        theme.palette.mode === "dark"
                          ? "#2186e3" // Lighter blue for hover in dark mode
                          : "#005da3", // Darker blue for hover in light mode
                    },
                "&:focus": {
                  outline: !searchedDetail
                    ? "none"
                    : `2px solid ${
                        theme.palette.mode === "dark" ? "#90caf9" : "#004d87"
                      }`,
                  outlineOffset: "2px",
                },
              }}
            >
              <SaveAltIcon
                fontSize="medium"
                style={{
                  paddingLeft: "5px",
                  paddingRight: "5px",
                  color: !searchedDetail
                    ? theme.palette.mode === "dark"
                      ? "rgba(255, 255, 255, 0.7)"
                      : "rgba(0, 0, 0, 0.38)"
                    : "#ffffff",
                }}
              />
              EXPORT
            </div>
          </Stack>


            {/* <Button
              color="blue"
              variant="contained"
              size="medium"
              style={{ margin: "10px" }}
              disabled={!searchedDetail}
              onClick={doExport}
            >
              <SaveAltIcon
                fontSize="medium"
                style={{
                  paddingLeft: "5px",
                  paddingRight: "5px",
                }}
              ></SaveAltIcon>
              Export
            </Button> */}
          </Box>
        )}
      </Box>
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Stack sx={style}>
          <Typography variant="h6" color="secondary">
            Enter Profile Name:
          </Typography>
          <TextField
            label={""}
            onChange={(e) => handleProfileChange(e)}
            value={profileName || ""}
            variant="standard"
          />
          <Button
            variant="contained"
            color="success"
            style={{ marginTop: "5px" }}
            onClick={saveProfile}
          >
            <SaveAltIcon
              fontSize="medium"
              style={{
                paddingLeft: "5px",
                paddingRight: "5px",
              }}
            ></SaveAltIcon>
            Save
          </Button>
        </Stack>
      </Modal>
    </UIWrapper>
  );
};

export default AcsExport;
